/**
  * THIS IS A GENERATED FILE. DO NOT ALTER DIRECTLY.
  */

 ;
import type { SVGProps } from "react";
interface SVGRProps {
  title?: string;
  titleId?: string;
}
const SvgBoltNotVisible = ({
  title,
  titleId,
  ...props
}: SVGProps<SVGSVGElement> & SVGRProps) => <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" aria-labelledby={titleId} {...props}>{title ? <title id={titleId}>{title}</title> : null}<path fill="currentColor" d="M12.253 10.073 13.33 2 10.22 7.653zM12.884 10.824l2.269 2.701 1.706-2.702zM14.312 14.856l-.002.003 3.317 3.95-1.15.965-3.007-3.584L9.8 22l1.177-8.235H6.859l1.811-3.293L5 6.1l1.148-.964z" /></svg>;
export default SvgBoltNotVisible;